module.exports = __webpack_public_path__ + "img/logo.84a31202.png";